import styled from 'styled-components';

export const GridWrapper = styled.section`
  margin: ${(props) =>
    props.parentingCommunity ? '40px 0 10px' : '50px 0 40px'};
  background: linear-gradient(
    to bottom,
    ${(props) => props.sectionBgColorStart},
    ${(props) => props.sectionBgColorEnd}
  );
  padding: ${(props) =>
    props.padding ? '30px 7.5%' : props.clinicExpert ? '0' : '0 7.5%'};
  @media (max-width: 720px) {
    margin: ${(props) =>
      props.happiness
        ? '16px 0'
        : props.isForNewCdPage
          ? '10px 0 30px'
          : '40px 0 30px'};
    padding: ${(props) => (props.padding ? '20px 0' : '0')};
    margin-top: ${(props) => (props.showNewGridView ? '0px' : '')};
  }
`;

export const GridBanner = styled.div`
  display: grid;

  grid-template-columns: ${(props) =>
    props.parenting ? 'repeat(4,1fr)' : `repeat(${props.gridSize},1fr)`};
  grid-gap: 24px;
  margin: ${(props) => (props.newDiaperVersion ? '0 0 16px' : '0 10px 16px')};

  .column_direction {
    display: flex;
    flex-direction: column;
  }
  .transitionClass {
    transition: all 0.2s ease-in-out;
  }
  .gridcardopacity {
    opacity: 0.5;
  }

  @media (max-width: 720px) {
    // display:${(props) => (props.gridSize == 1 ? 'none' : 'auto')};
    grid-gap: 10px;
    grid-template-columns: ${(props) =>
      props.mobileThreeGrid == 'LEFT' ||
      props.gridSize > 3 ||
      props.showNewGridView
        ? 'repeat(2,1fr)'
        : props.parenting
          ? 'repeat(1,1fr)'
          : 'repeat(1,1fr)'};
  }
`;

export const ImageBox = styled.div`
  text-align: ${(props) => (props.gridSize == 1 ? 'center' : 'auto')};
  &.lowOpacity {
    opacity: 0.4;
  }
`;

export const EffectAnchor = styled.span`
  cursor: pointer;
  &.lowOpacity {
    opacity: 0.4;
  }
  @media (max-width: 768px) {
    cursor: default;
  }
`;

export const ResponsiveImage = styled.img`
  width: 100%;
  max-width: ${(props) => (props.gridSize == 1 ? '1280px' : 'none')};
  height: 100%;
  box-shadow: ${(props) => (props.gridSize == 1 ? 'none' : ' none')};
  border-radius: ${(props) => props.borderRadius};
  transition:
    transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s;

  &:hover {
    transform: ${(props) => (props.gridSize == 1 ? 'none' : ' scale(1.026)')};

    @media (min-width: 720px) {
      cursor: pointer;
    }
  }
`;
export const ResponsiveImageDiv = styled.div`
  position: relative;
  width: 100%;
  div,
  span {
    position: unset !important;
  }

  .image {
    object-fit: contain;
    width: 100% !important;
    position: relative !important;
    height: unset !important;
    transition:
      transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
      box-shadow 0.3s ease 0s;

    &:hover {
      transform: ${(props) => (props.gridSize == 1 ? 'none' : ' scale(1.016)')};
    }
  }
  .carousel-desktop {
    @media (max-width: 720px) {
      display: none !important;
    }
  }
  .carousel-mobile {
    display: none !important;
    @media (max-width: 720px) {
      display: block !important;
    }
  }
`;

export const BannerTitle = styled.div`
  display: ${(props) => (props.fromSuccessPage ? 'none' : 'block')};
  text-align: ${(props) => (props.textWidget ? 'left' : 'center')};
  padding: ${(props) =>
    props.fromSearchPage
      ? '0'
      : props.browse
        ? '24px 0 0px 20px'
        : '0 12px 16px'};

  h2 {
    display: inline-block;
    color: hsl(0deg, 0%, 0%, 80%);
    position: relative;
    font-size: ${(props) =>
      props.fromBabyNames ? 'clamp(16px,2vw,22px)' : 'clamp(18px, 2vw, 24px)'};
    font-weight: 600;
    letter-spacing: ${(props) => (props.fromBabyNames ? '0' : '5px')};
    text-transform: capitalize;
    @media (max-width: 720px) {
      letter-spacing: ${(props) => (props.fromBabyNames ? '0' : '2px')};
      line-height: ${(props) => (props.fromBabyNames ? 'normal' : '32px')};
    }
  }

  h3 {
    font-size: clamp(14px, 2vw, 20px);
    font-weight: 500;
    letter-spacing: 3px;
    color: hsl(0deg, 0%, 0%, 54%);
    padding-top: 6px;
  }

  img {
    position: absolute;
    right: -16px;
    top: 0;
    width: 12px;
    height: 12px;
    display: none;
  }

  @media (max-width: 720px) {
    padding: ${(props) =>
      props.fromSearchPage
        ? '0'
        : props.browse
          ? '24px 0 10px 12px'
          : props.categoryPage
            ? props.isForNewCdPage
              ? '6px 0 0px'
              : '6px 0 20px'
            : props.fromBabyNames
              ? '0 12px 20px'
              : props.subHeading
                ? '0 16px 0px'
                : '0 16px 20px'};
  }
`;

export const GridBoxTitle = styled.h2`
  font-size: ${(props) =>
    props.ytVideo ? 'clamp(18px, 2vw, 19px)' : 'clamp(14px, 2vw, 19px)'};
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: hsl(0deg, 0%, 0%, 80%);
  text-align: ${(props) => (props.ytVideo ? 'left' : 'center')};
  padding: ${(props) => (props.browse ? '40px 0 18px' : '18px 0')};

  @media (max-width: 720px) {
    text-align: center;
    font-size: 16px;
  }
`;

export const GridBoxContent = styled.p`
  font-size: clamp(14px, 2vw, 16px);
  font-weight: ${(props) => (props.parenting ? '400' : '500')};
  color: hsl(0deg, 0%, 0%, 87%);
  line-height: 1.7;
  text-align: ${(props) => (props.ytVideo ? 'left' : 'center')};
  padding: ${(props) => (props.ytVideo ? '4px 0 14px' : '4px 22px 20px')};

  @media (max-width: 720px) {
    padding: ${(props) => (props.ytVideo ? '4px 0 14px' : ' 4px 0 4px')};
  }
`;
export const BannerSubTitle = styled.div`
  display: ${(props) => (props.fromSuccessPage ? 'none' : 'block')};
  text-align: ${(props) => (props.textWidget ? 'left' : 'center')};
  padding: ${(props) => (props.browse ? '24px 0 0px 20px' : '0 10px 30px')};
  h2 {
    display: inline-block;
    color: rgba(0, 0, 0);
    opacity: 0.6;
    position: relative;
    font-size: clamp(12px, 2vw, 18px);
    font-weight: 600;
    letter-spacing: 5px;
    text-transform: capitalize;
    @media (max-width: 720px) {
      letter-spacing: 2px;
      line-height: 32px;
    }
  }
`;
